// Fires a lightweight page-view beacon to /api/public/track on every route
// change made on the public sites. Admin / vendor / institute-admin paths are
// deliberately skipped so staff navigation isn't recorded.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const NON_PUBLIC_PREFIXES = [
  "/admin",
  "/institute/login",
  "/institute-portal",
  "/vendor/login",
  "/vendor/portal",
  "/vendor/apply",
];

function isPublicPath(path) {
  if (!path) return false;
  return !NON_PUBLIC_PREFIXES.some((p) => path === p || path.startsWith(p + "/"));
}

export default function VisitorTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname || "/";
    if (!isPublicPath(path)) return;
    // Fire-and-forget. withCredentials ensures the gsm_visitor_id cookie flows.
    try {
      api.post(
        "/public/track",
        {
          path,
          title: (typeof document !== "undefined" && document.title) || "",
          referrer: (typeof document !== "undefined" && document.referrer) || "",
        },
        { withCredentials: true }
      ).catch(() => {});
    } catch { /* ignore */ }
  }, [location.pathname]);

  return null;
}
